import { createContext } from "react";

const LogsContext = createContext();

export default LogsContext;
